<template>
  <div>
    <template>
      <p>
        <b-row>
          <b-col cols="12">
            <strong>
              <i class="fa fa-pencil"></i>
            </strong>
            {{ StoreLangTranslation.data['mail'][StoreLang] }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-input type="text" class="form-control-warning" id="mail" key="mail" :formatter="f_toLowerCase(d_supportDataMail.mail, 'mail')" v-model="d_supportDataMail.mail" :state="f_emailRegexCheck(d_supportDataMail.mail)"></b-form-input>
            <b-form-valid-feedback></b-form-valid-feedback>
            <b-form-invalid-feedback>
              {{ StoreLangTranslation.data['please_write_true_mail'][StoreLang] }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </p>

      <p>
        <b-row style="text-align: center;">
          <b-col cols="12">
            <div id="captcha"></div>
          </b-col>
        </b-row>
        <b-row style="text-align: center;">
          <b-col cols="12">
            <b-button size="sm" @click="f_createCaptcha()" variant="white"><i class="fa fa-edit" style="color: #45dc45;"></i>&nbsp; {{ StoreLangTranslation.data['change'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-form-input id="captchaCode" type="text" class="form-control-warning" required v-model="d_captchaWrittenCode" :state="d_captchaWrittenCode === d_captchaCode"></b-form-input>
              <b-form-valid-feedback></b-form-valid-feedback>
              <b-form-invalid-feedback>
                {{ StoreLangTranslation.data['write_captcha_code'][StoreLang] }}
              </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </p>

      <p v-if="d_mailApproveCodeSended === 'yes'">
        <b-row>
          <b-col cols="12">
            <strong>
              <i class="fa fa-pencil"></i>
            </strong>
            {{ StoreLangTranslation.data['mail_approve_code'][StoreLang] }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-input type="text" class="form-control-warning" id="mail_approve_code" key="mail_approve_code" v-model="d_mailApproveCode" :state="d_mailApproveCode.length === 6"></b-form-input>
            <b-form-valid-feedback></b-form-valid-feedback>
            <b-form-invalid-feedback>
              {{ StoreLangTranslation.data['please_write_mail_approve_code'][StoreLang] }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </p>

    </template>

    <b-row>
      <b-col cols="8">
      </b-col>
      <b-col cols="4">
        <template v-if="d_supportSaveLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <b-button :variant="f_controlSaveEligible() ? 'outline-success' : 'outline-danger'" @click="f_supportNew()" size="lg" style="width: 100%;" :disabled="!f_controlSaveEligible()">
              <i class="fa fa-send-o"></i>
              {{ StoreLangTranslation.data['send'][StoreLang] }}
            </b-button>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ClsRoute } from '@/wam/modules/route';
import { WisdomRegex } from '@/public/WisdomRegex';
import { data as support_list } from '@/wam/options/support_list';
import { ServiceFunctions } from '@/wam/modules/service';
import { mapGetters } from 'vuex';
export default {
  name: 'MailVerify',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreDevice: 'StoreDevice',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  props: {
    f_updateMailInfo: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      d_supportSaveLoading: false,
      d_mailApproveCode: '',
      d_mailApproveCodeSended: '',
      d_supportList: support_list,
      d_captchaWrittenCode: '',
      d_captchaCode: '',
      d_supportDataMail: {
        'maximum_characters_name': 100,
        'maximum_characters_note': 500,
        'mail_status': true,
        'phone_status': true,
        'phone': '',
        'mail': '',
        'show': false,
        'edit_eligible': true,
        'operation_name': '',
        'operation_note': '',
        'operation_note_additional': '',
        'maximum_characters': 500,
        'subject': 'General'
      },
    }
  },
  created: function () {},
  mounted: function () {
    this.f_createCaptcha();
  },
  methods: {
    f_formatText: function (value, param) {
      this.d_supportDataMail[param] = value.substring(0, this.d_supportDataMail.maximum_characters);
    },
    f_emailRegexCheck: function (email) {
      let status = WisdomRegex.email(email).status;
      this.d_supportDataMail.mail_status = status;
      return status;
    },
    f_toLowerCase: function (value, param) {
      this.d_supportDataMail[param] = value.toLowerCase();
    },
    f_controlSaveEligible: function() {
      let save_eligible = true;
      if (this.d_captchaWrittenCode !== this.d_captchaCode) {
        save_eligible = false;
      } else if (!this.d_supportDataMail.mail_status) {
        save_eligible = false;
      }
      return save_eligible;
    },
    f_createCaptcha: function() {
      this.d_captchaWrittenCode = '';
      this.d_captchaCode = '';
      //clear the contents of captcha div first 
      document.getElementById('captcha').innerHTML = "";
      let charsArray = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
      let lengthOtp = 6;
      let captcha = [];
      for (let i = 0; i < lengthOtp; i++) {
        //below code will not allow Repetition of Characters
        let index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
        if (captcha.indexOf(charsArray[index]) == -1)
          captcha.push(charsArray[index]);
        else i--;
      }
      let canv = document.createElement("canvas");
      canv.id = "captcha";
      canv.width = 100;
      canv.height = 50;
      let ctx = canv.getContext("2d");
      ctx.font = "25px Georgia";
      ctx.strokeText(captcha.join(""), 0, 30);
      //storing captcha so that can validate you can save it somewhere else according to your specific requirements
      this.d_captchaCode = captcha.join("");
      // console.log('this.d_captchaCode : ', this.d_captchaCode);
      document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
      this.$forceUpdate();
    },
    f_supportNew: function () {
      if (confirm(this.StoreLangTranslation.data['do_you_confirm_the_process'][this.StoreLang])) {
        let query = '';
        if (this.d_mailApproveCode && this.d_mailApproveCodeSended === 'yes') {
          query += 'mail_approve_code=' + this.d_mailApproveCode;
        }
        let data = {
          'mail': this.d_supportDataMail.mail,
        };
        this.d_supportSaveLoading = true;
        ServiceFunctions.mail_verify(query, data)
          .then(resp => {
            this.d_supportSaveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              if (resp.data.mail_already_has_user && resp.data.mail_already_has_user === 'yes') {
                alert(this.StoreLangTranslation.data['mail_already_has_user'][this.StoreLang]);
                this.$router.push({ path: '/login', query: {} });
              }
              else if (resp.data.mail_approve_code_sended && resp.data.mail_approve_code_sended === 'yes') {
                this.d_mailApproveCodeSended = 'yes';
              } else if (resp.data.mail_approve_code_check_success && resp.data.mail_approve_code_check_success === 'yes') {
                if (this.f_updateMailInfo) {
                  this.f_updateMailInfo(this.d_supportDataMail.mail, this.d_mailApproveCode);
                }
                // this.d_mailApproveCodeSended = '';
                // this.d_mailApproveCode = '';
                // this.d_supportDataMail.show = false;
                // alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
            this.$forceUpdate();
          });
      }
    },
  }
}
</script>
